import IconAdapterOld from './IconAdapterOld';
import IconGl2025 from './Icons/BaseIconAdapterGl2025';
import { ThemeComponentSwitcher } from '../styling/index';

const Icon = ThemeComponentSwitcher([
    { theme: 'gl2025', component: IconGl2025 },
    { theme: 'old', component: IconAdapterOld }
]);

export default Icon;
